// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-wrapper {
    display: flex;
    flex-direction: column;
    width: 24rem;
    background-color: #1b2053;
    color: white;
    border-right: 1px solid #242a65;
    transition: width 0.3s ease;
}

.sidebar-title h5 {
    font-size: 1rem;
    font-weight: bold;
    padding-left: 15px;
}

.sidebar-feed {
    padding: 1rem;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none;
}

.sidebar-feed::-webkit-scrollbar {
    display: none;
}

.sidebar-wrapper.collapsed {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    transition: left 0.3s ease;
    will-change: contents;
}

.sidebar-toggle {
    position: absolute;
    top: 25px;
    left: 350px;
    width: 24px;
    height: 24px;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    z-index: 10;
    transition: left 0.3s ease;
}

.sidebar-wrapper.collapsed .sidebar-toggle {
    top: 25px;
    left: 8px;
    transition: left 0.3s ease;
}

.sidebar-header,
.sidebar-title,
.sidebar-feed {
    transition: opacity 0.3s ease;
    will-change: opacity;
}

.sidebar-wrapper.collapsed .sidebar-header,
.sidebar-wrapper.collapsed .sidebar-title,
.sidebar-wrapper.collapsed .sidebar-feed {
    opacity: 0;
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/FeedSidebar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,SAAS;IACT,0BAA0B;AAC9B;;AAEA;;;IAGI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;;;IAGI,UAAU;IACV,oBAAoB;AACxB","sourcesContent":[".sidebar-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 24rem;\n    background-color: #1b2053;\n    color: white;\n    border-right: 1px solid #242a65;\n    transition: width 0.3s ease;\n}\n\n.sidebar-title h5 {\n    font-size: 1rem;\n    font-weight: bold;\n    padding-left: 15px;\n}\n\n.sidebar-feed {\n    padding: 1rem;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    scrollbar-width: none;\n}\n\n.sidebar-feed::-webkit-scrollbar {\n    display: none;\n}\n\n.sidebar-wrapper.collapsed {\n    width: 40px;\n    min-width: 40px;\n    max-width: 40px;\n    transition: left 0.3s ease;\n    will-change: contents;\n}\n\n.sidebar-toggle {\n    position: absolute;\n    top: 25px;\n    left: 350px;\n    width: 24px;\n    height: 24px;\n    font-size: 14px;\n    text-align: center;\n    line-height: 24px;\n    cursor: pointer;\n    z-index: 10;\n    transition: left 0.3s ease;\n}\n\n.sidebar-wrapper.collapsed .sidebar-toggle {\n    top: 25px;\n    left: 8px;\n    transition: left 0.3s ease;\n}\n\n.sidebar-header,\n.sidebar-title,\n.sidebar-feed {\n    transition: opacity 0.3s ease;\n    will-change: opacity;\n}\n\n.sidebar-wrapper.collapsed .sidebar-header,\n.sidebar-wrapper.collapsed .sidebar-title,\n.sidebar-wrapper.collapsed .sidebar-feed {\n    opacity: 0;\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
